import { render, staticRenderFns } from "./AdminTransactionPaidButton.vue?vue&type=template&id=1ae40675&"
import script from "./AdminTransactionPaidButton.vue?vue&type=script&lang=ts&"
export * from "./AdminTransactionPaidButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports